// Capability detection for the Video Studio's in-browser pipeline.
// Recording + caption burn-in rely on MediaRecorder (WebM) + canvas.captureStream,
// which are unsupported on Safari/iOS. Upload + server transcription work anywhere.

let cached = null;

export function getVideoCapabilities() {
  if (cached) return cached;
  if (typeof window === 'undefined') {
    return { canRecord: false, canBurnIn: false, isSafari: false };
  }
  const ua = navigator.userAgent || '';
  const isSafari = (/^((?!chrome|crios|android).)*safari/i.test(ua)) || /iPad|iPhone|iPod/.test(ua);
  const hasMediaDevices = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
  const hasMediaRecorder = typeof window.MediaRecorder !== 'undefined';
  let webmRecord = false;
  try {
    webmRecord = hasMediaRecorder && (
      MediaRecorder.isTypeSupported('video/webm;codecs=vp9,opus') ||
      MediaRecorder.isTypeSupported('video/webm')
    );
  } catch (_) { webmRecord = false; }
  let mp4Record = false;
  try {
    mp4Record = hasMediaRecorder && MediaRecorder.isTypeSupported('video/mp4');
  } catch (_) { mp4Record = false; }
  let hasCanvasCapture = false;
  try {
    hasCanvasCapture = typeof document.createElement('canvas').captureStream === 'function';
  } catch (_) { hasCanvasCapture = false; }

  let isMobile = false;
  try {
    isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua)
      || (('ontouchstart' in window) && window.matchMedia('(max-width: 820px)').matches);
  } catch (_) { isMobile = false; }

  cached = {
    // WebM (desktop Chrome/Edge) OR MP4 (iOS/Safari) both count as recordable.
    canRecord: hasMediaDevices && hasMediaRecorder && (webmRecord || mp4Record),
    // Burn-in needs canvas.captureStream + MediaRecorder. WebM (Chrome/Edge) or
    // MP4 (Safari/iOS) both work — the recorded clip is transcoded to MP4 after.
    canBurnIn: hasMediaRecorder && (webmRecord || mp4Record) && hasCanvasCapture,
    isSafari,
    isMobile,
  };
  return cached;
}
